// src/components/Dispatchdetails/RUTReceptorForm.jsx
import React, { useMemo, useState } from "react";
import { Box, Button, TextField, Typography, Chip, Stack } from "@mui/material";
import { collection, doc, updateDoc } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { db } from "../../firebase";
import { registrarCambioEnOrden } from "../../redux/accionsRegister";

const RUTReceptorForm = ({
  orderDetails,
  orderID,
  usuarioStorage,
  setOrderDetails,
}) => {
  const dispatch = useDispatch();
  const [userDniReceptor, setUserDniReceptor] = useState("");
  const [hasTypedDni, setHasTypedDni] = useState(false);

  const collectionRef = collection(
    db,
    `${process.env.REACT_APP_COL_USERS_ORDERS}`
  );

  const currentRut =
    orderDetails?.userDniReceptor || orderDetails?.deliveryRut || "";

  // Sanitiza como en tu versión original
  const nextSanitized = useMemo(() => {
    const raw = (userDniReceptor || "").trim();
    return raw
      .replace(/\s+/g, "")
      .replace(/[^\w]/gi, "")
      .replace(/K/gi, "0")
      .slice(0, 9);
  }, [userDniReceptor]);

  // Habilita guardar solo si hay algo nuevo y distinto al actual
  const canSave =
    hasTypedDni &&
    nextSanitized.length > 0 &&
    nextSanitized.toLowerCase() !== currentRut.trim().toLowerCase();

  const saveUserDniReceptor = async (e) => {
    e.preventDefault();
    if (!orderID || !canSave) return;

    const data = {
      date: new Date(),
      lastValue: currentRut,
      newValue: nextSanitized,
      orderId: orderID,
      type: "infoAdd",
      userId: usuarioStorage.uid,
      var: "userDniReceptor",
    };
    dispatch(registrarCambioEnOrden(data));

    const orderRef = doc(collectionRef, `${orderID}`);
    try {
      await updateDoc(orderRef, { userDniReceptor: nextSanitized });
      setOrderDetails((prev) => ({
        ...(prev || {}),
        userDniReceptor: nextSanitized,
      }));
      setUserDniReceptor("");
      setHasTypedDni(false);
    } catch (error) {
      console.log("Error guardando userDniReceptor", error);
    }
  };

  if (!orderDetails) return null;

  return (
    <Box
      component="form"
      onSubmit={saveUserDniReceptor}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        mt: 1,
        width: "100%",
      }}
    >
      {/* Título + estado actual */}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
        useFlexGap
        flexWrap="wrap"
      >
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mr: 1 }}>
          RUT del Receptor
        </Typography>
        {currentRut ? (
          <Chip
            size="small"
            color="primary"
            variant="outlined"
            label={`Actual: ${currentRut}`}
          />
        ) : (
          <Chip size="small" color="warning" label="Sin RUT registrado" />
        )}
      </Stack>

      {/* Campo + Botón responsive con mínimos y alturas iguales */}
      <Stack
        direction={{ xs: "column", md: "row" }} // apilado en mobile, fila en >= md
        spacing={1.25}
        alignItems={{ xs: "stretch", md: "center" }}
        sx={{ width: "100%", flexWrap: "nowrap" }}
      >
        <TextField
          fullWidth
          value={userDniReceptor}
          onChange={(e) => {
            setUserDniReceptor(e.target.value);
            setHasTypedDni(true);
          }}
          placeholder="Ingrese RUT"
          variant="outlined"
          inputProps={{ maxLength: 12, inputMode: "text" }}
          helperText={
            !hasTypedDni
              ? "Escribe el RUT del receptor"
              : !canSave
              ? "Debe ser distinto al actual y no estar vacío"
              : "Listo para guardar"
          }
          sx={{
            minWidth: { md: 280 }, // mínimo en escritorio
          }}
        />

        <Button
          variant="contained"
          type="submit"
          disabled={!canSave}
          sx={{
            backgroundColor: "#591E8F",
            color: "#fff",
            px: 2,
            height: { xs: "44px", md: "56px" }, // iguala altura al TextField
            width: { xs: "100%", md: "auto" }, // full en móvil, auto en >= md
            minWidth: { md: 160 }, // mínimo en escritorio
            whiteSpace: "nowrap",
            "&:hover": { backgroundColor: "#25b2f4", color: "#591e8f" },
          }}
        >
          Guardar RUT
        </Button>
      </Stack>
    </Box>
  );
};

export default RUTReceptorForm;
